export const isThermalInspection = inspection => inspection.inspectionDomain === 'SOLAR_PANEL' || inspection.inspectionDomain === 'THERMAL_PIPELINE' || inspection.imageModality === 'THERMAL';
export function summarizeThermal(inspections, screenings) {
  const thermal = inspections.filter(isThermalInspection);
  const states = {DONE:0,RUNNING:0,PENDING:0,FAILED:0};
  let notStarted=0, unavailable=0;
  for(const inspection of thermal.filter(i=>i.inspectionDomain==='SOLAR_PANEL')) {
    const screening=screenings[inspection.id];
    if(!screening) {unavailable++;continue;}
    if(!screening.tasks.length) notStarted++;
    for(const task of screening.tasks) if(Object.hasOwn(states,task.status)) states[task.status]++;
  }
  return {inspections:thermal,projects:new Set(thermal.map(i=>i.projectId)).size,images:thermal.reduce((n,i)=>n+Number(i.imagesCount||0),0),states,notStarted,unavailable,
    domains:[{name:'Solar panels',value:thermal.filter(i=>i.inspectionDomain==='SOLAR_PANEL').length},{name:'Thermal pipeline',value:thermal.filter(i=>i.inspectionDomain==='THERMAL_PIPELINE').length},{name:'Other thermal',value:thermal.filter(i=>!['SOLAR_PANEL','THERMAL_PIPELINE'].includes(i.inspectionDomain)).length}]};
}
// Bound request concurrency for portfolios with many projects/inspections.
export async function mapLimited(items, fn, signal) {
  const results=new Array(items.length);let next=0;
  await Promise.all(Array.from({length:Math.min(4,items.length)},async()=>{
    while(!signal.aborted && next<items.length){const index=next++;try{results[index]={value:await fn(items[index])};}catch(error){results[index]={error};}}
  }));return results;
}
